import React, { createRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import toast from 'react-hot-toast';
import { Input, Select, Spinner } from '../../../components';
import { classNames, Constants, formatMiles, sanitizeToNumbers, roundConversion } from '../../../utils';
import { GeneralService, PurchasesService } from '../../../services';
import { Vector4 } from '../../../assets/img';
import { CloseIcon, PDFIcon, UploadFileIcon } from '../../../assets/icons';

const format = (amount) => {
	return parseFloat(parseFloat(amount).toFixed(2));
};

const getTotals = (total) => {
	const subtotal = format(total);
	let igtf = 0;
	let iva = 0;
	let amount = 0;

	// iva = format((total * Constants.TAXES.IVA) / 100);
	// igtf = format((total * Constants.TAXES.IGTF) / 100);
	amount = format(subtotal + igtf + iva);

	return { subtotal, igtf, iva, amount };
};

class PaymentTransferManual extends React.Component {

	state = {
		isLoading: false,
		request: this.props.request?.purchase,
		form: {
			paymentMethodId: Constants.PAYMENT.METHOD.TRANSFER_MANUAL,
			bankId: '',
			date: '',
			dniType: '',
			dni: '',
			phoneCode: '',
			phone: '',
			reference: '',
			conversion: 0,
			voucher: '',
			amountVED: 0,
			...getTotals(this.props.request?.purchase.total),
		},
		banks: [],
		dniTypes: [],
		phoneCodes: [],
	}

	confirmModalRef = createRef();
  cartButtonRef = createRef();
  goBack = createRef();

	componentDidMount() {
    this.cartButtonRef.current = document.getElementById('header-cart');
    this.cartButtonRef.current.classList.add('hidden');
    this.goBack.current = document.getElementById('header-goback');
    this.goBack.current.classList.remove('hidden');

    if (!this.props.request?.purchase) this.props.history.replace('/');

		this.getSelects();
	}

  componentWillUnmount() {
    this.cartButtonRef.current.classList.remove('hidden');
    this.goBack.current.classList.add('hidden');
  }

	getSelects = async () => {
		Promise.all([
			GeneralService.getBanks(),
			GeneralService.getDocumentTypes(),
			GeneralService.getPhoneCodes(),
			GeneralService.getConversion(),
			GeneralService.getPaymentMethodInfo(Constants.PAYMENT.METHOD.TRANSFER),
		])
			.then(res => {
				const conversion = res[3].find(x => x.currency_id === Constants.CURRENCY.USD)?.amount ?? 0;

				this.setState({
					banks: res[0].map(x => ({ value: x.id, label: x.name })) ?? [],
					dniTypes: res[1] ?? [],
					phoneCodes: res[2] ?? [],
					data: res[4][0],
					form: {
						...this.state.form,
						amountVED: format(this.state.form.amount * roundConversion(conversion)),
						conversion,
					},
				});
			})
			.catch(console.log);
	}

	change = (value,target) => {
		this.setState({
			form: { ...this.state.form, [target]: value },
		});
	}

	submit = async () => {
		if (!this.isValidForm()) return;

		const { form, request } = this.state;

		const data = {
			payment: {
				...form,
				date: moment(form.date).format('YYYY-MM-DD'),
			},
			request: {
				...request,
				conversion: form.conversion,
			},
			hasFile: false,
		};

		if (form.voucher) {
			data.hasFile = true;
			data.voucher = form.voucher;
			data.payment.voucher = undefined;
		}

		this.props.request?.products?.forEach(cartItem => {
			cartItem.beneficiaries.forEach(benef => {
				// Agrega los documentos requeridos a la raíz del objeto
				if (benef?.required_docs?.length) {
					benef?.required_docs.filter(x => !!x.file)?.forEach(x => {
						data.hasFile = true;
						const itemName = `required_docs_${x.id}_${benef.id}`;
						data[itemName] = x.file;
						data.request[itemName] = undefined;
					});
				}
			});
		});

		if (data.hasFile) {
			data.payment = JSON.stringify(data.payment);
			data.request = JSON.stringify(data.request);
		}

		try {
			await this.setState({ isLoading: true }); 
			await PurchasesService.create(data);
			this.props.dispatch({ type: 'SET_REQUEST', payload: {} });
			this.props.dispatch({ type: 'SET_CART', payload: [] });
			this.confirmModalRef.current?.showModal();

		} catch (error) {
			console.log(error);
		}

		await this.setState({ isLoading: false }); 
	}

	isValidForm = (showError = true) => {
		const onError = (msg) => {
			if (showError) toast.error(msg);
			return false;
		};

		const { form } = this.state;

		if (!form.bankId)
			return onError('El banco es obligatorio');

		if (!form.date)
			return onError('La fecha es obligatoria');

		if (!form.dniType)
			return onError('El tipo de documento es obligatorio');

		if (!form.dni)
			return onError('La cédula es obligatoria');

		if (!form.phoneCode)
			return onError('El código de área es obligatorio');

		if (!form.phone)
			return onError('El teléfono es obligatorio');

		if (!form.reference)
			return onError('La referencia es obligatoria');

		return true;
	}

	closeConfirmModal = () => {
		this.confirmModalRef.current?.close();
		this.props.history.push('/');
	}

	selectVoucher = (voucher) => {
		this.setState(s => ({
			form: { ...s.form, voucher, voucherBlob: URL.createObjectURL(voucher) },
		}));
	}

	render() {

		const isNextStepEnabled = this.isValidForm(false);
		const { data, form, isLoading } = this.state;

		let icon = UploadFileIcon;
		if (form.voucher) {
			icon = form.voucherBlob;
			if (form.voucher?.type === 'application/pdf' || String(form).endsWith('pdf')) icon = PDFIcon;
		}

		return (
			<>
				{isLoading && (
					<div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
						<Spinner />
					</div>
				)}

				<dialog
					ref={this.confirmModalRef}
					className="fixed inset-0 z-50 overflow-y-auto bg-transparent"
					onClose={this.closeConfirmModal}
				>
					<div
						className="w-[20rem] bg-white rounded-xl overflow-hidden p-4 flex flex-col items-center"
						onClick={this.closeConfirmModal}
					>
						<button className="absolute top-3 right-3">
							<img src={CloseIcon} className="w-4 h-4 object-contain" alt="" />
						</button>

						<img src={Vector4} className="w-32 h-32 object-contain" alt="" />
						<p className="text-center font-semibold">
							Su pago será validado por el administrador
						</p>
					</div>
				</dialog>

				<div className="w-full sm:w-[30rem] mx-auto flex flex-col gap-4 mt-8 lg:mt-0">
					<div className="w-full pt-2">
						<p className="text-center font-bold text-darkBlue text-3xl mb-2">
							{ formatMiles(form.amountVED,2,'Bs') }
						</p>

						<div className="[&>div]:flex [&>div]:justify-between">
							<div>
								<p className="font-semibold text-gray3 text-sm">Banco</p>
								<p className="font-semibold text-gray3 text-sm">
									{`${ data?.bank?.code ?? '' } - ${ data?.bank?.name ?? '' }`.trim()}
								</p>
							</div>
							<div>
								<p className="font-semibold text-gray3 text-sm">RIF</p>
								<p className="font-semibold text-gray3 text-sm">{ data?.dni ?? '-' }</p>
							</div>
							<div>
								<p className="font-semibold text-gray3 text-sm">Tipo de Cuenta</p>
								<p className="font-semibold text-gray3 text-sm">{ data?.account_type ?? '-' }</p>
							</div>
							<div>
								<p className="font-semibold text-gray3 text-sm">N° de Cuenta</p>
								<p className="font-semibold text-gray3 text-sm">{ data?.account_number ?? '-' }</p>
							</div>
						</div>

						<div className="border-t border-[#AAAAAA] my-2" />

						<p className="font-semibold text-darkBlue mt-5 mb-2">
							Verificar pago
						</p>

						<div className="flex flex-col gap-y-4">
							<Select
								placeholder="Banco"
								items={this.state.banks}
								value={form.bankId}
								onValueChange={v => this.change(v,'bankId')}
							/>

							<div className="flex flex-row items-center">
								<div className="w-1/3">
									<Select
										items={this.state.dniTypes}
										value={form.dniType}
										onValueChange={v => this.change(v,'dniType')}
									/>
								</div>
								<div className="w-2/3 pl-4">
									<Input
										placeholder="Cédula"
										value={form.dni}
										onValueChange={v => this.change(sanitizeToNumbers(v),'dni')}
										maxLength={8}
									/>
								</div>
							</div>

							<div className="flex flex-row items-center">
								<div className="w-1/3">
									<Select
										items={this.state.phoneCodes}
										value={form.phoneCode}
										onValueChange={v => this.change(v,'phoneCode')}
									/>
								</div>
								<div className="w-2/3 pl-4">
									<Input
										placeholder="Número"
										value={form.phone}
										onValueChange={v => this.change(sanitizeToNumbers(v),'phone')}
										maxLength={7}
									/>
								</div>
							</div>

							<Input
								type="date"
								placeholder="Fecha de pago"
								value={form.date}
								onValueChange={v => this.change(v,'date')}
							/>

							<label className="flex items-center gap-2 cursor-pointer">
								<div className="w-10 h-10 bg-[#DDDDDD] rounded-md overflow-hidden flex justify-center items-center">
									{form.voucher ?
										(icon === PDFIcon
											? <img key="image" src={icon} className="w-7 h-7 object-cover grayscale opacity-75" alt="" />
											: <img key="image" src={icon} className="w-10 h-10 object-cover" alt="" />)
									: (
										<img key="placeholder" src={UploadFileIcon} className="w-7 h-7 object-cover invert opacity-65" alt="" />
									)}
								</div>
								<p className="text-sm">Subir comprobante (Opcional)</p>

								<input
									type="file"
									className="hidden"
									accept="application/pdf,image/jpeg,image/png"
									onChange={e => this.selectVoucher(e.target.files[0])}
								/>
							</label>

							<Input
								placeholder="Últimos 4 números"
								value={form.reference}
								onValueChange={v => this.change(sanitizeToNumbers(v),'reference')}
								maxLength={4}
							/>
						</div>
					</div>

					<div>
						<button
							className={classNames(
								'rounded-lg w-full text-center h-10 font-bold my-2 disabled:bg-gray6 disabled:text-gray3',
								isNextStepEnabled ? 'bg-yellow text-black' : 'text-gray bg-gray6'
							)}
							onClick={this.submit}
							disabled={!isNextStepEnabled}
						>
							<span>Aceptar</span>
						</button>
					</div>
				</div>
			</>
		);
	}
}

export default connect(state => ({
	request: state.request,
	user: state.user,
}))(PaymentTransferManual);
